import React from "react";
import "./LuxurySteps.css";

interface StepItem {
  id: number;
  title: string;
  text: string;
  curved?: boolean;
  first?: boolean;
  middle?: boolean;
  icon?: React.ElementType; // <-- new optional icon property
}

interface LuxuryStepsProps {
  steps?: StepItem[];
}

export default function LuxurySteps({ steps = [] }: LuxuryStepsProps) {
  return (
    <section className="luxury-steps">
      <div className="steps-container">
        {steps.map((step) => {
          const Icon = step.icon;
          return (
            <div
              key={step.id}
              className={`step-card 
                ${step.curved ? "curved" : ""} 
                ${step.first ? "first" : ""} 
                ${step.middle ? "middle" : ""}`}
            >
              <div className="step-number">
                {Icon ? <Icon size={40} color="#e8ddc1" /> : step.id}
              </div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-text">{step.text}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
